import React from "react";
import { Tag, Collapse } from "antd";

export const buildAdminCollapseItem = ({
  headerTitle,
  headerSubtitle,
  headerTagText,
  headerTagColor = "blue",
  headerTags,
  items = [],
  children,
  actions,
  key,
}) => {
  return {
    key: key,
    showArrow: false,
    label: (
      <div className="flex items-center justify-between gap-3 w-full pr-2 flex-wrap sm:flex-nowrap">
        <div className="flex flex-col text-left">
          <span className="font-gilroyBold text-[15px] sm:text-[16px] text-gray-900 leading-snug">
            {headerTitle}
          </span>
          {headerSubtitle && (
            <span className="text-[13px] text-gray-500 font-medium mt-0.5">
              {headerSubtitle}
            </span>
          )}
        </div>
        <div className="flex items-center gap-1.5 flex-wrap sm:flex-nowrap shrink-0">
          {Array.isArray(headerTags) && headerTags.length > 0 ? (
            headerTags.map((tag, idx) => (
              <Tag
                key={idx}
                color={tag.color === "black" ? "black" : tag.color || "blue"}
                className={`font-gilroyBold uppercase text-[12px] px-2.5 py-0.5 rounded-lg border-0 m-0 ${
                  tag.color === "black" ? "bg-black text-white" : ""
                } ${tag.className || ""}`}
              >
                {tag.text}
              </Tag>
            ))
          ) : headerTagText ? (
            <Tag
              color={headerTagColor === "black" ? "black" : headerTagColor}
              className={`font-gilroyBold uppercase text-[12px] px-2.5 py-0.5 rounded-lg border-0 m-0 flex-shrink-0 ${
                headerTagColor === "black" ? "bg-black text-white" : ""
              }`}
            >
              {headerTagText}
            </Tag>
          ) : null}
        </div>
      </div>
    ),
    children: (
      <div>
        {children ? (
          children
        ) : (
          <ul className="mobile-list-flex space-y-2">
            {items.map((item, i) => (
              <li
                key={i}
                className={
                  item.fullWidth
                    ? "py-1.5 space-y-1 flex flex-col items-start w-full"
                    : "flex gap-4 justify-between items-center py-1"
                }
              >
                <span
                  className={`text-[13px] whitespace-nowrap ${
                    item.fullWidth
                      ? "font-gilroyBold text-gray-700 mb-0.5"
                      : "text-gray-600 font-medium"
                  }`}
                >
                  {item.label}:
                </span>
                <div className={`text-[13px] text-gray-900 font-medium ${item.fullWidth ? "w-full text-left" : "text-right"}`}>{item.value}</div>
              </li>
            ))}
          </ul>
        )}

        {actions && (
          <div className="mt-4 flex gap-2 flex-wrap items-center border-t border-gray-100 pt-3">
            {actions}
          </div>
        )}
      </div>
    ),
  };
};

export const AdminCollapseList = ({ items = [], defaultActiveKey = [] }) => {
  return (
    <div className="mobile topup-data">
      <Collapse items={items} defaultActiveKey={defaultActiveKey} />
    </div>
  );
};

export default buildAdminCollapseItem;
